<template>
  <div
    :class="{
      'app': true,
      'minisieNav__app': minisizeMenu || $route.meta.isIframe || $route.meta.isOrtherModule,
      'full-nav': !minisizeMenu && !minisizeSubNav,
      'open-one-nav': !(minisizeMenu && minisizeSubNav) && (minisizeMenu || minisizeSubNav),
      'is-minisieNav': minisizeMenu,
      'is-minisizeSubNav': minisizeSubNav,
      'is-orther-module-minisizeNav': $route.meta.isOrtherModule && minisizeMenuNav,
      'sidebar-lg-show': true,
      'mobile-sidebar-open': mobileSidebarOpen,
      'have-sidebar-right': false, //currentUser.account == 'siten_haitn'
      'sidebar-ceo': true,
      'have-sub-sidebar': $route.meta.isOrtherModule && !currentUser.roles.includes('AdminSystem'),
      'timwook': $route.meta.isIframe
    }"
  >
    <div
      v-if="mobileSidebarOpen"
      class="mobile-sidebar-overlay"
      @click="closeMobileSidebar"
    ></div>
    <!-- v-if="currentUser.account != 'siten_haitn'" -->
    <AppHeader
      :class="{
        'minisieNav__header': minisizeMenu || $route.meta.isIframe,
        'minisizeSubNav__header': minisizeSubNav,
        'fullNav__header': !minisizeMenu && !$route.meta.isIframe,
        'fullSubNav__header': !minisizeSubNav,
      }"
      v-if="
        $router.currentRoute.meta.collection != 'Dashboard' &&
        $router.currentRoute.meta.collection != 'DashboardCEO' &&
        $router.currentRoute.meta.collection != 'DashboardHR' &&
        $router.currentRoute.meta.collection != 'DashboardBusiness'
      "
    >
      <button
        type="button"
        class="navbar-toggler d-lg-none mobile-sidebar-toggler"
        aria-label="Mở menu"
        @click="toggleMobileSidebar"
      >
        <span class="mobile-sidebar-toggler__icon"></span>
      </button>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <BreadCrumd v-if='$route.meta.breadCrumb && $route.meta.breadCrumb.length > 0' />
      <DocumentBreadCrumb v-show="$route.meta.collection == 'Document'" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownSetting />
      </b-navbar-nav>
    </AppHeader>
    <AppSidebar
      fixed
      :class="{
        'isIframe': $route.meta.isIframe,
        'minisieNav': !isMobileSidebar && (minisizeMenu || $route.meta.isIframe || minisizeMenuNav),
        'isIframeCheck': $route.meta.isIframe,
        'mobile-sidebar': isMobileSidebar,
        'is-open': mobileSidebarOpen,
      }"
    >
      <SidebarTop
        class="sidebar-mobile-top"
        :minisizeMenus="isMobileSidebar ? false : ($route.meta.isIframe || minisizeMenu)"
        :isAnotherModuleAndMinisize="isMobileSidebar ? true : !minisizeMenuNav"
      />
       <!-- && currentUser.account != 'siten_haitn' -->
      <div v-if="!$route.meta.isIframe" class="navbar__minisize">
        <div @click="showHideMenu()" class="icon__show-hide">
          <el-image class="icon" src="img/arrow-square-right.png" fit="cover"></el-image>
        </div>
      </div>
      <SidebarNavCustom
        class="sidebar-mobile-menu"
        :minisizeMenu="isMobileSidebar ? false : (minisizeMenu || $route.meta.isIframe)"
        :listNav="nav"
        :mobileSubNav="navSub"
        :mobileSubNavCollection="$router.currentRoute.meta.collection"
        @close-mobile-sidebar="closeMobileSidebar"
      />
      <SidebarBottom
        class="sidebar-mobile-bottom"
        :minisizeMenu="isMobileSidebar ? false : (minisizeMenu || $route.meta.isIframe)"
        :isAnotherModuleAndMinisize="minisizeMenuNav"
      />
    </AppSidebar>
    <div
      v-if="
        $route.meta.isOrtherModule &&
        !currentUser.roles.includes('AdminSystem') &&
        $router.currentRoute.meta.collection != 'Document' &&
        $router.currentRoute.meta.collection != 'DocumentDrafting'
      "
      :class="{
        'sub-nav': true,
        'document-drafting': $router.currentRoute.meta.collection == 'DocumentDrafting',
        'timekeeping': $router.currentRoute.meta.collection == 'Timekeeping',
        'setting': $router.currentRoute.meta.collection == 'Setting',
        'dashboard': $router.currentRoute.meta.collection == 'Dashboard' ||
                    $router.currentRoute.meta.collection == 'DashboardCEO' ||
                    $router.currentRoute.meta.collection == 'DashboardHR' ||
                    $router.currentRoute.meta.collection == 'DashboardBusiness',
        'minisizeSubNav': minisizeSubNav,
      }"
    >
      <div class="subnavbar__minisize" v-if="$router.currentRoute.meta.collection == 'Timekeeping' || $router.currentRoute.meta.collection == 'Setting'">
        <div @click="showHideSubMenu()" class="icon__show-hide">
          <el-image class="icon" src="img/arrow-square-right.png" fit="cover"></el-image>
        </div>
      </div>
      <SidebarSubNavCustom
        :minisizeMenu="minisizeSubNav"
        v-if="showSubNav"
        :listNav="navSub"
      />
    </div>
    <div :class="{
      'app-body': true,
      'document-drafting': $router.currentRoute.meta.collection == 'DocumentDrafting',
      'document': $router.currentRoute.meta.collection == 'Document',
      'timekeeping': $router.currentRoute.meta.collection == 'Timekeeping',
      'dashboard':  $router.currentRoute.meta.collection == 'Dashboard' ||
                    $router.currentRoute.meta.collection == 'DashboardCEO' ||
                    $router.currentRoute.meta.collection == 'DashboardHR' ||
                    $router.currentRoute.meta.collection == 'DashboardBusiness',
    }">
      <main class="main">
        <div :class="{
          isIframe: $route.meta.isIframe,
          'container-fluid': true,
          'lunch-container-fluid': $router.currentRoute.name == 'Admin-LunchRegistration' ||
            $router.currentRoute.name == 'Admin-LunchMenuManagement' ||
            $router.currentRoute.name == 'Admin-LunchRegistrationList' ||
            $router.currentRoute.name == 'Admin-LunchRegistrationHistory',
          'lunch-menu-management-container-fluid': $router.currentRoute.name == 'Admin-LunchMenuManagement',
          'document-drafting-category-container-fluid': $router.currentRoute.name == 'Admin-DocumentDrafting-category-list',
          'sign-process': $router.currentRoute.name == 'Admin-DocumentDrafting-sign-process',
          'detail-approve': $router.currentRoute.name == 'Admin-DocumentDrafting-detail-approve',
        }">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <RightSidebar
      v-if="
        $router.currentRoute.meta.collection == 'Dashboard' ||
        $router.currentRoute.meta.collection == 'DashboardCEO' ||
        $router.currentRoute.meta.collection == 'DashboardHR' ||
        $router.currentRoute.meta.collection == 'DashboardBusiness'
      "
    ></RightSidebar>
  </div>
</template>

<script>

import MethodService from "@/service/MethodService";
import navTimekeeping from "@/views/nav/_nav-timekeeping";
import navCeo from "@/views/nav/_navCEO";
import navDocumentDrafting from "@/views/nav/_nav-document-drafting";
import navSystemAdmin from "@/views/nav/_nav-system-admin";
import EventBus from "@/service/EventBus";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import SidebarTop from "./SidebarTop";
import SidebarBottom from "./SidebarBottom";
import DefaultHeaderDropdownSetting from "./DefaultHeaderDropdownSetting";
import SidebarNavCustom from "./SidebarNavCustom";
import SidebarSubNavCustom from "./SidebarSubNavCustom";
import RightSidebar from "./RightSidebar";
import BreadCrumd from "./BreadCrumd";
import DocumentBreadCrumb from './DocumentBreadCrumb'
import LanguageService from "../service/LanguageService";
import EmployeeApi from "../moduleApi/EmployeeApi";
import { store } from '../store/store';

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarTop,
    SidebarBottom,
    RightSidebar,
    DefaultHeaderDropdownSetting,
    SidebarToggler,
    SidebarNav,
    SidebarNavCustom,
    SidebarSubNavCustom,
    BreadCrumd,
    DocumentBreadCrumb,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      nav: [],
      navCeo: MethodService.copyObject(navCeo.items),
      navSystemAdmin: MethodService.copyObject(navSystemAdmin.items),
      currentUser: MethodService.getCurrentUser(),
      navSub: [],
      prevUrl: null,
      minisizeMenu: true,
      minisizeMenuNav: false,
      minisizeSubNav: false,
      showSubNav: true,
      isMobileSidebar: window.innerWidth < 768,
      mobileSidebarOpen: false
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    },
  },
  methods: {
    fn_isSelectedEmployeeRole() {
      const currentRoleName = (localStorage.getItem('currentRoleName') || '')
        .trim()
        .toLowerCase();
      return currentRoleName === 'nhân viên' || currentRoleName === 'nhan vien';
    },
    showHideMenu() {
      this.minisizeMenu = !this.minisizeMenu
      this.minisizeMenuNav = !this.minisizeMenuNav
      EventBus.$emit('changeSizeMenuSalary')
      EventBus.$emit('changeSizeMenuTax')
      EventBus.$emit('changeSizeMenuInsurance')
      EventBus.$emit('changeSizeMenu', !this.minisizeMenu )
    },
    showHideSubMenu() {
      this.minisizeSubNav = !this.minisizeSubNav
    },
    toggleMobileSidebar() {
      if (window.innerWidth >= 768) return;
      this.mobileSidebarOpen = !this.mobileSidebarOpen;
      document.body.classList.toggle("mobile-sidebar-open", this.mobileSidebarOpen);
      document.body.classList.remove("sidebar-show");
      document.documentElement.classList.remove("sidebar-show");
    },
    closeMobileSidebar() {
      if (window.innerWidth >= 768) return;
      this.mobileSidebarOpen = false;
      this.$el.classList.remove("sidebar-show");
      document.body.classList.remove("mobile-sidebar-open");
      document.body.classList.remove("sidebar-show");
      document.documentElement.classList.remove("sidebar-show");
    },
    updateMobileSidebarState() {
      this.isMobileSidebar = window.innerWidth < 768;
      if (!this.isMobileSidebar) {
        this.mobileSidebarOpen = false;
        document.body.classList.remove("mobile-sidebar-open");
        document.body.classList.remove("sidebar-show");
        document.documentElement.classList.remove("sidebar-show");
      }
    },
    async fn_getNav() {
      this.navSub = []
      let listFeature = MethodService.getListFeatures()
      let employeeRole = MethodService.getListEmployeeRoles();
      const currentEmployeeRoleCode = MethodService.getCurrentEmployeeRoleCode();
      let roleCodesForNav = ["*"];
      if (currentEmployeeRoleCode) {
        roleCodesForNav = [currentEmployeeRoleCode];
      } else if (employeeRole && employeeRole.length > 0) {
        roleCodesForNav = employeeRole;
      } else if (this.currentUser.roles.includes("AdminSystem")) {
        roleCodesForNav = ["*", "AdminSystem"];
      }
      let currentUser = MethodService.getCurrentUser();
      let currentUserProfile = MethodService.getUserProfile();
      // let arrNav = MethodService.copyObject(nav.items);
      let navMain = this.currentUser.roles.includes("AdminSystem") ? MethodService.copyObject(this.navSystemAdmin) : MethodService.copyObject(this.navCeo);
      if (this.$router.currentRoute.meta.collection == 'DocumentDrafting') {
        this.navSub = MethodService.copyObject(navDocumentDrafting.items);
      } else if (this.$router.currentRoute.meta.collection == 'Timekeeping') {
        this.navSub = MethodService.copyObject(navTimekeeping.items);
      } else {
        this.navSub = [];
      }
      if (currentUserProfile && currentUserProfile.type == 'COMPANY' && !this.currentUser.roles.includes("AdminSystem")) {
        let arrNavAdmin = [
          '/admin/dashboard-individual'
        ];
        let navMainFilter = navMain.filter(item => arrNavAdmin.includes(item.url) == false);
        this.nav = navMainFilter;
      } else {
        this.nav = [];
        $.each(navMain, (indexNav, metaNav) => {
          let canAccess = metaNav.meta.allowAccess.some(allowAccess =>
            allowAccess == "*" ||
            roleCodesForNav.includes(allowAccess) ||
            listFeature.includes(allowAccess)
          );
          if (canAccess) {
            this.nav.push(metaNav);
          }
        });
        // console.log('this.nav',this.nav);
        // this.nav = navMain;
      }
      if (!this.currentUser.roles.includes("AdminSystem")) {
        this.nav = this.nav.filter((item) => item.url !== "/admin/System/Company/list");
      }
      this.nav = this.nav.filter((metaNav) => {
        const codes = metaNav.meta && metaNav.meta.code;
        if (!codes || codes.length === 0 || codes.includes("*")) {
          return true;
        }
        return codes.some((code) => listFeature.includes(code));
      });
      if (this.fn_isSelectedEmployeeRole()) {
        this.nav = this.nav.filter((item) => {
          return !["/admin/dashboard-ceo", "/admin/dashboard-hr"].includes(item.url);
        });
      }
      $.each(this.navSub, (indexNar1, valueNarLever1) => {
        //Check theo role
        if (
          valueNarLever1.meta.allowAccess &&
          valueNarLever1.meta.allowAccess.length > 0
        ) {
          //check quyền truy cập Nav1
          $.each(
            valueNarLever1.meta.allowAccess,
            (indexMeta1, valueMetaLever1) => {
              if (
                currentUser.roles.indexOf(valueMetaLever1) != -1 ||
                valueMetaLever1 == "*"
              ) {
                valueNarLever1.meta.allowRole = true;
              }
            },
            valueNarLever1.meta.code,
            (indexCode1, valueCode1) => {
              if (listFeature.indexOf(valueCode1) != -1) {
                valueNarLever1.meta.allowFeature = true;
              }
            }
          );
          //check xem tồn tại Nav2
          if (valueNarLever1.children && valueNarLever1.children.length > 0) {
            $.each(valueNarLever1.children, (indexNar2, valueNarLever2) => {
              if (
                valueNarLever2.meta.allowAccess &&
                valueNarLever2.meta.allowAccess.length > 0
              ) {
                //check quyền truy cập Nav2
                $.each(
                  valueNarLever2.meta.allowAccess,
                  (indexMeta2, valueMetaLever2) => {
                    if (
                      currentUser.roles.indexOf(valueMetaLever2) != -1 ||
                      valueMetaLever2 == "*"
                    ) {
                      valueNarLever2.meta.allowRole = true;
                    }
                  },
                  valueNarLever2.meta.code,
                  (indexCode2, valueCode2) => {
                    if (listFeature.indexOf(valueCode2) != -1) {
                      valueNarLever2.meta.allowFeature = true;
                    }
                  }
                );
                //check xem tồn tại Nav3
                if (valueNarLever2.children && valueNarLever2.children.length > 0) {
                  $.each(valueNarLever2.children, (indexNar3, valueNarLever3) => {
                    if (
                      valueNarLever3.meta.allowAccess &&
                      valueNarLever3.meta.allowAccess.length > 0
                    ) {
                      //check quyền truy cập Nav3
                      $.each(
                        valueNarLever3.meta.allowAccess,
                        (indexMeta3, valueMetaLever3) => {
                          if (
                            currentUser.roles.indexOf(valueMetaLever3) != -1 ||
                            valueMetaLever3 == "*"
                          ) {
                            valueNarLever3.meta.allowRole = true;
                          }
                        },
                        valueNarLever3.meta.code,
                        (indexCode3, valueCode3) => {
                          if (listFeature.indexOf(valueCode3) != -1) {
                            valueNarLever3.meta.allowFeature = true;
                          }
                        }
                      );
                      //Mở rộng thêm ở đây
                    }
                  });
                }
              }
            });
          }
        }
        //Check theo feature code
        if (valueNarLever1.meta.code && valueNarLever1.meta.code.length > 0) {
          //check quyền truy cập Nav1
          $.each(valueNarLever1.meta.code, (indexCode1, valueCode1) => {
            if (listFeature.indexOf(valueCode1) != -1) {
              valueNarLever1.meta.allowFeature = true;
            }
          });
          //check xem tồn tại Nav2
          if (valueNarLever1.children && valueNarLever1.children.length > 0) {
            $.each(valueNarLever1.children, (indexNar2, valueNarLever2) => {
              if (valueNarLever2.meta.code && valueNarLever2.meta.code.length > 0) {
                //check quyền truy cập Nav2
                $.each(valueNarLever2.meta.code, (indexCode2, valueCode2) => {
                  if (listFeature.indexOf(valueCode2) != -1) {
                    valueNarLever2.meta.allowFeature = true;
                  }
                });
                //check xem tồn tại Nav3
                if (valueNarLever2.children && valueNarLever2.children.length > 0) {
                  $.each(valueNarLever2.children, (indexNar3, valueNarLever3) => {
                    if (valueNarLever3.meta.code && valueNarLever3.meta.code.length > 0) {
                      //check quyền truy cập Nav3
                      $.each(valueNarLever3.meta.code, (indexCode3, valueCode3) => {
                        if (listFeature.indexOf(valueCode3) != -1) {
                          valueNarLever3.meta.allowFeature = true;
                        }
                      });
                      //Mở rộng thêm ở đây
                    }
                  });
                }
              }
            });
          }
        }
      });
      $.each(this.navSub, (indexNar1, valueNarLever1) => {
        //Check theo feature code
        if (valueNarLever1.meta.code && valueNarLever1.meta.code.length > 0) {
          //check quyền truy cập Nav1
          $.each(valueNarLever1.meta.code, (indexCode1, valueCode1) => {
            if (listFeature.indexOf(valueCode1) != -1) {
              valueNarLever1.meta.allowFeature = true;
            }
          });
          //check xem tồn tại Nav2
          if (valueNarLever1.children && valueNarLever1.children.length > 0) {
            $.each(valueNarLever1.children, (indexNar2, valueNarLever2) => {
              if (valueNarLever2.meta.code && valueNarLever2.meta.code.length > 0) {
                //check quyền truy cập Nav2
                $.each(valueNarLever2.meta.code, (indexCode2, valueCode2) => {
                  if (listFeature.indexOf(valueCode2) != -1) {
                    valueNarLever2.meta.allowFeature = true;
                  }
                });
                //check xem tồn tại Nav3
                if (valueNarLever2.children && valueNarLever2.children.length > 0) {
                  // eslint-disable-next-line no-undef
                  $.each(valueNarLever2.children, (indexNar3, valueNarLever3) => {
                    if (valueNarLever3.meta.code && valueNarLever3.meta.code.length > 0) {
                      //check quyền truy cập Nav3
                      $.each(valueNarLever3.meta.code, (indexCode3, valueCode3) => {
                        if (listFeature.indexOf(valueCode3) != -1) {
                          valueNarLever3.meta.allowFeature = true;
                        }
                      });
                      //Mở rộng thêm ở đây
                    }
                  });
                }
              }
            });
          }
        }
      });
      //Check Lọc quyền Nav1 và trả về mảng đã lọc arrNavFilter
      let arrNavFilter = this.navSub.filter(function (value, index, arr) {
        return value.meta.allowRole == true && value.meta.allowFeature == true;
      });
      $.each(arrNavFilter, function (indexNavF1, valueNavF1) {
        //check tồn tại Nav2
        if (valueNavF1.children && valueNavF1.children.length > 0) {
          // Lọc quyền Nav2 và trả về mảng đã lọc arrNavFilter2
          // debugger
          let arrNavFilter2 = valueNavF1.children.filter(function (value2, index2, arr2) {
            return value2.meta.allowRole == true && value2.meta.allowFeature == true;
          });
          //gán mảng Nav2 đã lọc vào mảng mẹ
          valueNavF1.children = arrNavFilter2;
          $.each(arrNavFilter2, function (indexNavF12, valueNavF2) {
            //check tồn tại Nav3
            if (valueNavF2.children && valueNavF2.children.length > 0) {
              // Lọc quyền Nav3 và trả về mảng đã lọc arrNavFilter3
              var arrNavFilter3 = valueNavF2.children.filter(function (
                value3,
                index3,
                arr3
              ) {
                return value3.meta.allowRole == true && value3.meta.allowFeature == true;
              });
              //gán mảng Nav3 đã lọc vào mảng mẹ
              valueNavF2.children = arrNavFilter3;
              // Mở rộng tiếp theo ở đây
            }
          });
        }
      });
      if (currentUser.roles.includes("AdminSystem")) {
        const URLRoleSystemAdmin = [
          "/admin/home",
          "/admin/employee/home",
          "/admin/dashboard-ceo",
          "/admin/dashboard-hr",
          "/admin/dashboard-business",
          "/admin/dashboard-individual",
          "/admin/Timekeeping",
          "/admin/Timekeeping/Worksheet",
          "/admin/AssignWork",
          "/admin/ManageRequests",
          "/admin/EmployeeManager/list",
          "/admin/Salary/SalaryPeriod/SalaryPeriodList",
          "/admin/developing-page",
          "/admin/System",
        ];
        const arrNavFilter4 = arrNavFilter.filter(
          (x) => URLRoleSystemAdmin.includes(x.url) == false
        );
        arrNavFilter = arrNavFilter4;
      }
      const URLForEmployee = [
        "/admin/employee/home",
        "/admin/Timekeeping/Employee/EmployeeWorksheet",
        "/admin/SalaryEmployee/list",
      ];
      const employeeApiRes = await EmployeeApi.findById(currentUser.id, true);
      if (!employeeApiRes.result) {
      // if (currentUserProfile.type != 'Company') {
        const arrNavFilter5 = arrNavFilter.filter(
          (x) => URLForEmployee.includes(x.url) == false
        );
        arrNavFilter = arrNavFilter5;
      }
      // Gán mảng mẹ vào Nav Main
      this.navSub = arrNavFilter;
      store.commit("setNavSub", this.navSub)
    },
  },
  async created() {
    if (window.innerWidth < 1480) {
      this.minisizeSubNav =  true
    }
    await this.fn_getNav();
    if (
      (
        this.$route.meta.isOrtherModule ||
        this.$route.meta.isIframe ||
        this.$route.meta.collection == "Document" ||
        this.$route.meta.collection == "Business" ||
        this.$route.meta.collection == "News" ||
        this.$route.meta.collection == "DocumentDrafting" ||
        this.$route.meta.collection == 'HelloPage'||
        this.$route.meta.collection == 'UserInfo'||
        this.$route.meta.collection == 'DashboardIndividual'
      ) &&
      !this.currentUser.roles.includes('AdminSystem')
    ) {
      this.minisizeMenuNav = true;
    }
    if (
      this.currentUser.roles.includes('AdminSystem') ||
      this.$route.meta.collection == 'Dashboard' ||
      this.$route.meta.collection == 'DashboardHR' ||
      this.$route.meta.collection == 'DashboardCEO' ||
      this.$route.meta.collection == 'DashboardBusiness'
      // || this.$route.meta.collection == 'DashboardIndividual'
    ) {
      this.minisizeMenu = false;
    }
    document.addEventListener("mousemove", (e) => {
      if (window.innerWidth < 768) return;
      if (!e.target.closest(".nav-item.nav-dropdown")) return;
      if (!e.target.closest(".nav-item.nav-dropdown")) return;
      const dropdownItem = e.target.closest(".nav-item.nav-dropdown");
      if (dropdownItem.closest(".sub-nav")) return;
      let dom = dropdownItem.children;
      let clientX = dropdownItem.getBoundingClientRect();
      let heightFromBottomToMenu = window.innerHeight - clientX.bottom;
      let dropdownList = dom[1];
      if (!dropdownList) return;
      let childrenDom = dropdownList.children;
      let childrenHeight = dropdownList.scrollHeight || childrenDom.length * 70;
      let maxHeight;
      if (heightFromBottomToMenu < 400) {
        if (childrenHeight > heightFromBottomToMenu) {
          dropdownList.style.bottom = "40px";
          dropdownList.style.top = "";
        } else {
          dropdownList.style.top = `${clientX.top + 30}px`;
          dropdownList.style.bottom = "";
        }
        maxHeight = window.innerHeight - 100;
        dropdownList.style.maxHeight = `${maxHeight}px`;
      } else {
        dropdownList.style.top = `${clientX.bottom - 20}px`;
        dropdownList.style.bottom = "";
        if (childrenHeight < heightFromBottomToMenu) {
          maxHeight = childrenHeight;
        } else {
          maxHeight = heightFromBottomToMenu - 33;
        }
        dropdownList.style.maxHeight = `${maxHeight}px`;
      }
      dropdownList.style.overflowY = childrenHeight > maxHeight ? "auto" : "hidden";
      dropdownList.style.overflowX = "hidden";
    });

    window.onresize = () => {
      this.updateMobileSidebarState()
      if (window.innerWidth < 1480) {
        this.minisizeMenu = true
        this.minisizeMenuNav = true
        this.minisizeSubNav =  true
      }
    }

    EventBus.$off("ChangeRouteDefault");
    EventBus.$on("ChangeRouteDefault", () => {
      this.showSubNav = false
        setTimeout(() => {
          this.fn_getNav()
          setTimeout(() => {
            this.showSubNav = true
          }, 300)
        }, 500)
      if (
        (
          this.$route.meta.isOrtherModule ||
          this.$route.meta.isIframe ||
          this.$route.meta.collection == "Document" ||
          this.$route.meta.collection == "Business" ||
          this.$route.meta.collection == "News" ||
          this.$route.meta.collection == 'HelloPage'||
          this.$route.meta.collection == 'UserInfo'||
          this.$route.meta.collection == "DocumentDrafting"
        ) &&
        !this.currentUser.roles.includes('AdminSystem')
      ) {
        this.minisizeMenu = true
        this.minisizeMenuNav = true
      } else {
        if (this.minisizeMenuNav == true) return
        this.minisizeMenuNav = false
      }
      if (
        this.currentUser.roles.includes('AdminSystem') ||
        this.$route.meta.collection == 'Dashboard' ||
        this.$route.meta.collection == 'DashboardHR' ||
        this.$route.meta.collection == 'DashboardCEO' ||
        this.$route.meta.collection == 'DashboardBusiness'
      ) {
        this.minisizeMenu = false
      }
    });
  },
};
</script>

<style scoped lang="scss">
.main {
  position: relative;
}
/* Có sidebar right */
.app.have-sidebar-right{
  .app-body{
    .main {
      position: relative;
      height: 100vh;
      margin-right: var(--widthRightSidebar) !important;
      .container-fluid{
        padding: 15px 15px 10px 20px;
        &.sign-process {
          padding: 0;
        }
        .card {
          .main-card-body {
            min-height: 100vh !important;
          }
        }
      }
    }
  }
}
/* End css sidebar right */
body {
  background-color: var(--backgroundBody) !important;
}
.main .container-fluid.isIframe {
  padding: 0;
}
.main .container-fluid.lunch-container-fluid {
  margin-top: 0;
  padding-top: 40px;
}
.main .container-fluid.lunch-menu-management-container-fluid {
  box-sizing: border-box;
  overflow-x: visible;
  overflow-y: auto;
  padding: clamp(12px, 1.2vw, 20px) 10px clamp(10px, 1vw, 16px) clamp(14px, 1.5vw, 24px);
}
.main .container-fluid.document-drafting-category-container-fluid {
  margin-left: 0;
  margin-top: 0;
  padding: 0;
}
.main .container-fluid.document-drafting-category-container-fluid .animated {
  padding-top: 0;
  min-height: calc(100vh - 65px) !important;
}
@media (max-width: 1099px) {
  .main .container-fluid.lunch-menu-management-container-fluid {
    overflow-x: visible;
    overflow-y: auto;
  }
}
::v-deep .navbar-nav.ml-auto {
  flex-shrink: 0;
  padding-top: 8px;
  padding-bottom: 10px;
  padding-right: 10px;
}
.app-header {
  flex-wrap: nowrap;
  border-bottom-right-radius: 5px;
  border: 1px solid #d8dbe0;
  border-left: none;
  border-top: none;
  box-shadow: 7px 7px 21px -7px rgba(0, 0, 0, 0.1);
}


.sidebar-lg-show .app-header .header-fixed .app-body {
  margin-top: 65px;
}
.el-scrollbar__bar {
  opacity: 1 !important;
}
.navbar__minisize, .subnavbar__minisize {
  height: 30px;
  width: 100%;
  position: relative;
  z-index: 6;
  .icon__show-hide {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 5px;
  }
  .icon__show-hide:hover {
    cursor: pointer;
  }
}

::v-deep .nav-icon::before {
  font-size: 25px;
  color: var(--black);
}
.nav-icon.none {
  padding-left: 20px;
}
.sidebar {
  .navbar__minisize {
    .icon {
      transform: rotate(0);
      transition: transform 0.5s linear;
    }
  }
}
.sub-nav {
  .subnavbar__minisize {
    .icon__show-hide {
      .icon {
        transform: rotate(0);
        transition: transform 0.5s linear;
      }
    }
  }
}
/* Minisize Nav */
::v-deep .sidebar.minisieNav {
  width: 80px;
  .navbar__minisize {
    .icon {
      transform: rotate(-180deg);
      transition: transform 0.5s linear;
    }
  }
  .nav-item {
    width: 80px;
    overflow: hidden;
    .nav-link {
      position: relative;
      padding-left: 15px;
      margin: 0;
      white-space: nowrap;
    }
  }
}
/* Minisize SubNav */
::v-deep .sub-nav.minisizeSubNav {
  width: 80px;
  .subnavbar__minisize {
    .icon {
      transform: rotate(-180deg);
      transition: transform 0.5s linear;
    }
  }
  .nav-item {
    width: 80px;
    overflow: hidden;
    .nav-link {
      position: relative;
      padding-left: 15px;
      margin: 0;
      white-space: nowrap;
    }
  }
  .nav-dropdown-items {
    .nav-item {
      width: 210px;
      overflow: hidden;
      .nav-link {
        position: relative;
        padding-left: 15px;
        margin: 0;
        white-space: nowrap;
      }
    }
  }
}
::v-deep .ps.ps--active-x > .ps__scrollbar-x-rail,
::v-deep .ps.ps--active-y > .ps__scrollbar-y-rail {
  display: none;
}
::v-deep .sidebar.minisieNav .ps {
  overflow-x: hidden !important;
}
.app-body .main {
  margin-left: 0 !important;
}
::v-deep .sidebar.minisieNav .nav-item.nav-dropdown:hover {
  width: 80px;
  overflow: hidden;
}
::v-deep .sidebar.minisieNav .nav > .nav-dropdown:hover > .nav-dropdown-items {
  border-radius: 10px;
  position: fixed;
  left: 51px;
  display: inline;
  overflow: hidden;
  z-index: 1;
  box-shadow: 0px 0px 30px rgba(0, 3, 32, 0.2);
  padding: 10px;
}
::v-deep .sidebar.minisieNav .nav-dropdown-items .nav-item,
::v-deep .sidebar.minisieNav .nav-dropdown-items .nav-item .nav-link {
  width: 210px;
}
::v-deep .sidebar.minisieNav .nav-dropdown-toggle::before {
  display: none;
}
@media (max-width: 1480px) {
  .minisieNav {
    .navbar__minisize {
      .icon__show-hide {
        display: none;
      }
    }
  }
  .minisizeSubNav {
    .subnavbar__minisize {
      .icon__show-hide {
        display: none;
      }
    }
  }
}
@media (min-width: 992px) {
  .sidebar-fixed .app-header + .app-body .sidebar {
    height: calc(100vh - 55px);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .sidebar-lg-show .app-header {
    width: 100vw;
    margin-left: 0;
  }
  .sidebar-lg-show.sidebar-show .app-header {
    width: calc(100vw - 260px);
    margin-left: 260px;
  }
}
@media (max-width: 767px) {
  .sidebar-lg-show .app-header {
    width: 100vw;
    margin-left: 0;
  }
  .app {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }
  .app.mobile-sidebar-open {
    height: 100vh;
    overflow: hidden;
  }
  .app-header {
    z-index: 100;
  }
  ::v-deep .mobile-sidebar,
  ::v-deep .sidebar.mobile-sidebar,
  ::v-deep .sidebar.mobile-sidebar.minisieNav {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: auto;
    width: min(85vw, 320px) !important;
    min-width: min(85vw, 320px) !important;
    max-width: 320px;
    height: 100dvh;
    margin-left: 0;
    margin-right: 0;
    flex: 0 0 auto;
    flex-shrink: 0;
    box-sizing: border-box;
    z-index: 1200;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
    transform: translate3d(-100%, 0, 0);
    transition: transform 0.25s ease, visibility 0s linear 0.25s;
  }
  .app.mobile-sidebar-open ::v-deep .mobile-sidebar,
  ::v-deep .mobile-sidebar.is-open {
    visibility: visible;
    pointer-events: auto;
    transform: translate3d(0, 0, 0);
    transition: transform 0.25s ease, visibility 0s;
  }
  ::v-deep .sidebar > .sidebar-nav,
  ::v-deep .sidebar .sidebar_scroll {
    width: 100%;
    max-width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
  ::v-deep .sidebar > div {
    min-height: 0;
  }
  ::v-deep .sidebar-mobile-top,
  ::v-deep .sidebar-mobile-bottom {
    flex: 0 0 auto;
  }
  ::v-deep .sidebar-mobile-menu {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }
  ::v-deep .sidebar-mobile-menu .sidebar_scroll {
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  ::v-deep .sidebar-mobile-bottom .logout-div,
  ::v-deep .sidebar-mobile-bottom.logout-div {
    padding: 14px 18px;
    border-top: 1px solid #f1f1f1;
    background: #fff;
  }
  ::v-deep .sidebar-mobile-bottom .logout {
    display: flex;
    align-items: center;
    min-height: 44px;
    max-width: none;
  }
  .app-body {
    width: 100%;
    max-width: 100%;
    margin-left: 0 !important;
    min-width: 0;
    overflow-x: hidden;
  }
  .app-body .main {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin-left: 0 !important;
    overflow-x: hidden;
  }
  .main .container-fluid {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin-left: 0;
    padding: 10px;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  ::v-deep .mobile-sidebar-toggler {
    width: 44px;
    height: 44px;
    min-width: 44px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--orange);
    opacity: 1;
  }
  ::v-deep .mobile-sidebar-toggler .mobile-sidebar-toggler__icon {
    width: 22px;
    height: 2px;
    position: relative;
    display: block;
    background: var(--orange);
    opacity: 1;
  }
  ::v-deep .mobile-sidebar-toggler .mobile-sidebar-toggler__icon::before,
  ::v-deep .mobile-sidebar-toggler .mobile-sidebar-toggler__icon::after {
    content: "";
    position: absolute;
    left: 0;
    width: 22px;
    height: 2px;
    background: var(--orange);
  }
  ::v-deep .mobile-sidebar-toggler .mobile-sidebar-toggler__icon::before {
    top: -7px;
  }
  ::v-deep .mobile-sidebar-toggler .mobile-sidebar-toggler__icon::after {
    top: 7px;
  }
  .mobile-sidebar-overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: rgba(0, 0, 0, 0.55);
  }
  ::v-deep .sidebar {
    z-index: 1200;
  }
  .sub-nav.timekeeping,
  .sub-nav.setting {
    display: none;
    width: 0;
    margin-left: 0;
  }
  .app.mobile-sidebar-open .sub-nav.timekeeping,
  .app.mobile-sidebar-open .sub-nav.setting {
    display: none;
  }
  .navbar__minisize {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .sidebar {
    height: 100vh;
  }
}
@media (max-width: 767px) {
  .sidebar-lg-show.mobile-sidebar-open .app-header {
    width: 100vw;
    margin-left: 0;
  }
}
@media (max-width: 750px) {
  .main .container-fluid {
    padding: 10px;
    margin-left: 0;
  }
}
</style>
